// @ts-nocheck


import React, { Component } from 'react';
import { connect } from 'react-redux';
import { navigate } from '../../lib/routerAdapter';
import styled from 'styled-components';

import notification from 'antd/lib/notification';

import type { OrgUnitNode, UserAccess } from './../../lib/types';
import { goBack } from '../../lib/helpers';
import { accessTypeEnum } from '../../lib/enum';
import type { AppState } from '../../ducks/redux';

import { Panel } from './../../components/layout';
import Header from '../../components/layout/Header';
import Breadcrumbs, { Crumb } from '../../components/layout/Breadcrumbs';
import { notificationLoading } from './../../components/Notifications';

import { selectOrgUnit } from './../../ducks/selectors';
import { updateOrgUnit, addOrgUnit } from './../../ducks/orgUnits';
import InnerForm from './components/InnerForm';
import InnerCard from './components/InnerCard';

const StyledPanel = styled(Panel)`
  padding-top: 0;
`;

const notificationWithDestroy = notification as typeof notification & {
  destroy: (key: string) => void;
};

const getErrorMessage = (error: unknown) =>
  error instanceof Error ? error.message : String(error);

type Props = {
  userAccess?: UserAccess[],
  orgUnit: OrgUnitNode | null,
  updateOrgUnit: (orgUnit: OrgUnitNode) => Promise<void>,
  addOrgUnit: (orgUnit: OrgUnitNode, parentId: number) => Promise<void>,
  parentOrgUnitId: number
};

class OrgUnitForm extends Component<Props> {
  canAdd = () =>
    (this.props.userAccess ?? []).some(access =>
      [
        accessTypeEnum.admin,
        accessTypeEnum.adminBranch,
        accessTypeEnum.handlingOrgUnits
      ].includes(access)
    );
  render() {
    const { orgUnit, parentOrgUnitId } = this.props;
    return (
      <>
        <Header
          left={
            <Breadcrumbs>
              <Crumb to="/">Главная</Crumb>
              <Crumb to="/admin/org-units">Подразделения</Crumb>
              {orgUnit ? (
                <Crumb to={`/admin/org-units/${orgUnit.id}`}>
                  Подразделение №{orgUnit.id}
                </Crumb>
              ) : (
                <Crumb to={`/admin/org-units/${parentOrgUnitId}/new`}>
                  Новое подразделение
                </Crumb>
              )}
            </Breadcrumbs>
          }
        />
        <StyledPanel>
          <h1>
            {orgUnit ? `Подразделение №${orgUnit.id}` : 'Новое подразделение'}
          </h1>
        </StyledPanel>
        {this.canAdd() ? (
          <InnerForm
            orgUnit={
              orgUnit || ({ parentId: parentOrgUnitId } as OrgUnitNode)
            }
            onCancel={() => goBack('/admin/org-units')}
            onSubmit={async values => {
              try {
                notificationLoading({
                  message: 'Сохранение данных...',
                  key: 'saving'
                });
                if (values.id) {
                  await this.props.updateOrgUnit(values);
                } else {
                  await this.props.addOrgUnit(
                    values,
                    this.props.parentOrgUnitId
                  );
                }
                notification.success({
                  message: 'Успешно сохранено',
                  description: 'Изменения успешно сохранены'
                });
                navigate('/admin/org-units');
              } catch (error) {
                notification.error({
                  message: 'Ошибка',
                  description: getErrorMessage(error)
                });
              } finally {
                notificationWithDestroy.destroy('saving');
              }
            }}
          />
        ) : (
          <InnerCard
            orgUnit={
              orgUnit || ({ parentId: parentOrgUnitId } as OrgUnitNode)
            }
          />
        )}
      </>
    );
  }
}

export default connect(
  (
    state: AppState,
    ownProps: { orgUnitId: string; parentOrgUnitId: string }
  ) => ({
    userAccess: state.auth.profile.access,
    orgUnit: selectOrgUnit(parseInt(ownProps.orgUnitId, 10))(state),
    parentOrgUnitId: parseInt(ownProps.parentOrgUnitId, 10)
  }),
  {
    updateOrgUnit,
    addOrgUnit
  }
)(OrgUnitForm);
